import React, { ReactNode } from 'react'

import { UIProvider } from './UIContext'

interface AppProviderProps {
    children: ReactNode
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
    return <UIProvider>{children}</UIProvider>
}
